import { Box, Stack, Typography } from "@mui/material";

import { groupMessages } from "../utils/groupMessages";
import { formatSmartTimestamp } from "../utils/formatTimestamp";
import { styles } from "../styles";
import { MessageGroupBubble } from "./messageGroupBubble";
import { AiChatMessage } from "types/auth";
import { AI_CHAT_GROUPING_INTERVAL } from "config/config-general";

type MessageListProps = {
  messages: AiChatMessage[];
};

export function MessageList({ messages }: MessageListProps) {
  const groups = groupMessages(messages);

  const firstAssistantGroupIndex = groups.findIndex(
    (group) => group.role === "assistant"
  );

  return (
    <Stack spacing={2}>
      {groups.map((group, index) => {
        const previous = groups[index - 1];

        const showTime =
          index === 0 ||
          group.createdAt - (previous?.createdAt ?? 0) > AI_CHAT_GROUPING_INTERVAL;

        const showStartupText =
          group.role === "assistant" && index === firstAssistantGroupIndex;

        return (
          <Box key={group.id}>
            {showTime && (
              <Typography sx={styles.timestamp}>
                {formatSmartTimestamp(group.createdAt)}
              </Typography>
            )}

            <MessageGroupBubble
              group={group}
              showStartupText={showStartupText}
            />
          </Box>
        );
      })}
    </Stack>
  );
}